<dap-lib-popup
  [isOpen]="true"
  [title]="'COMMON.LANGUAGE_SWITCH.POPUP.TITLE' | translate"
  (cancel)="cancelSelection.emit()"
  data-cy="api-language-selector-popup"
  data-analytics="api-language-selector-popup"
>
  <div class="content" ngProjectAs="content">
    {{ 'COMMON.LANGUAGE_SWITCH.POPUP.TEXT' | translate }}
    <div class="language-buttons">
      <dap-lib-button
        *ngFor="let option of languageOptions"
        (click)="languageSelectionClicked(option)"
        [attr.data-cy]="'switch-language_' + option.id"
        buttonSize="medium"
        variant="secondary"
        class="stretch"
      >
        {{ option.label }}
      </dap-lib-button>
    </div>
  </div>
</dap-lib-popup>
